import { NavContext } from '@ionic/react';
import { useContext, useEffect } from 'react';

import { registerShellNav } from '@/core/router/shell-nav-controller';

/**
 * Registers Ionic tab {@link NavContext} for sidebar navigation outside `IonTabs`.
 */
export function ShellNavBridge() {
  const nav = useContext(NavContext);

  useEffect(() => {
    if (nav) {
      registerShellNav(nav);
      return () => registerShellNav(null);
    }
    return undefined;
  }, [nav]);

  return null;
}
